export default function onSystemColorThemeChanged(callback: () => void) {
  const darkModePreference = globalThis.matchMedia('(prefers-color-scheme: dark)');

  darkModePreference.addEventListener('change', callback);
}
